import Seo from "../components/Seo";

export default function AboutPage() {
  return (
    <div data-testid="about-page" className="max-w-[1100px] mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-20">
      <Seo
        title="About DealVest — Built by entrepreneurs, for entrepreneurs"
        description="DealVest bridges entrepreneurs, investors, and opportunities across Africa and the Middle East. Built from 20+ years of real operator experience."
        path="/about"
      />
      <span className="dv-eyebrow">About DealVest</span>
      <h1 className="dv-display text-4xl md:text-6xl mt-3 mb-8 max-w-3xl leading-tight">Bridging entrepreneurs, investors, and opportunity.</h1>
      <div className="grid lg:grid-cols-2 gap-12 mt-12 items-start">
        <div className="space-y-5 text-slate-700 text-lg leading-relaxed">
          <p>DealVest exists because too many good businesses fail before they become great — not for lack of potential, but for lack of capital, partners, and pathways.</p>
          <p>Across Africa and the Middle East, thousands of profitable businesses struggle to access funding, find qualified buyers, or identify strategic partners. Investors, in turn, struggle to find vetted opportunities.</p>
          <p>We solve this with a trusted, AI-powered marketplace built specifically for our region.</p>
        </div>
        <img src="https://images.pexels.com/photos/7433840/pexels-photo-7433840.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" alt="Boardroom" className="rounded-2xl w-full aspect-[4/5] object-cover" />
      </div>
      <div className="grid lg:grid-cols-2 gap-5 mt-16">
        <div className="bg-blue-50 rounded-2xl p-8 border border-blue-100">
          <div className="dv-eyebrow mb-3">Vision</div>
          <p className="dv-display text-2xl leading-snug">To become Africa and the Middle East's leading business acquisition and investment marketplace.</p>
        </div>
        <div className="bg-slate-900 rounded-2xl p-8 text-white">
          <div className="text-xs font-semibold tracking-widest uppercase text-blue-300 mb-3">Mission</div>
          <p className="dv-display text-2xl leading-snug">To help entrepreneurs build, grow, acquire, fund, and exit successfully.</p>
        </div>
      </div>
    </div>
  );
}
